import React from 'react'
import { CustomForm } from '../../CustomForm'

export const ModalAgregar = ({ camposAgregar, queryCrear, setRefetch, setOpenModal }) => {

    return (
        <>
            <CustomForm
                key={99}
                camposFormulario={camposAgregar}
                querySubmit={queryCrear}
                setRefetch={setRefetch}
                setOpenModal={setOpenModal}
                create={false}
            />
        </>
    )
}
